Object.defineProperty(exports, "__esModule", { value: true });
exports.avonV2DarkColorTokens = exports.avonV2LightColorTokens = void 0;
var avon_v2_light_1 = require("./avon_v2-light");
Object.defineProperty(exports, "avonV2LightColorTokens", { enumerable: true, get: function () { return avon_v2_light_1.avonV2LightColorTokens; } });
var avon_v2_dark_1 = require("./avon_v2-dark");
Object.defineProperty(exports, "avonV2DarkColorTokens", { enumerable: true, get: function () { return avon_v2_dark_1.avonV2DarkColorTokens; } });
//# sourceMappingURL=index.js.map